import { Injectable } from '@angular/core';
import { PassengerInformationInputModalEditArea } from '@common/helpers/constants/my-booking/passenger-information-input-modal.constant';
import { PassengerInformationInputModalCommonService } from './passenger-information-input-modal.common.service';
import { GetOrderResponseDataContactsUpgradeNotification } from 'src/sdk-servicing/model/getOrderResponseDataContactsUpgradeNotification';
import {
  UpgradeNotificationEmail,
  UpgradeNotificationEmailData,
  UpgradeNotificationEmailParts,
} from '@common/interfaces/mybooking/modals/passenger-information-input/upgrade-notification-email.interface';

/**
 * アップグレード通知メール情報 service
 */
@Injectable()
export class UpgradeNotificationEmailService {
  constructor(private readonly _s04CommonSvc: PassengerInformationInputModalCommonService) {}

  /**
   * アップグレード通知メール情報 初期値の作成
   * @param upgradeNotification アップグレード通知メール
   * @returns アップグレード通知メール情報 初期値
   */
  createData(upgradeNotification: GetOrderResponseDataContactsUpgradeNotification): UpgradeNotificationEmailData {
    return {
      emails:
        upgradeNotification?.emails?.map(
          (email) =>
            ({
              address: email?.address ?? '',
              confirmAddress: email?.address ?? '',
            } as UpgradeNotificationEmail)
        ) ?? [],
      isError: false,
    };
  }

  /**
   * アップグレード通知メール情報 設定値の作成
   * @param upgradeNotification アップグレード通知メール
   * @returns アップグレード通知メール情報 設定値
   */
  createParts(upgradeNotification: GetOrderResponseDataContactsUpgradeNotification): UpgradeNotificationEmailParts {
    const isEditMode = this._s04CommonSvc.isEditMode(PassengerInformationInputModalEditArea.UPGRADE_NOTIFICATION);
    // 項目名: アップグレード通知メール情報表示可否
    // 値: アップグレード通知メール情報.contacts.upgradeNotification.emailsの要素数>0の場合、true 上記以外、false
    const isRegistered = (upgradeNotification?.emails && upgradeNotification.emails.length > 0) ?? false;
    const registrationLabel = this._s04CommonSvc.getRegistrationLabel(isEditMode, isRegistered);
    const registrationClass = this._s04CommonSvc.getRegistrationLabelClass(registrationLabel);

    return {
      isDisplay: isRegistered,
      registrationLabel: registrationLabel,
      registrationClass: registrationClass,
    };
  }
}
